export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '官方认证',
      description: '成91官方认证平台入口，安全可靠，信息实时同步更新，确保您始终通过正规渠道访问。',
    },
    {
      icon: 'ri-guide-line',
      title: '详尽教程',
      description: '提供从注册到高级功能的完整使用教程，图文并茂，让您快速上手成91平台。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '贴心服务',
      description: '7×24小时客服支持，专业团队随时待命，解决您在使用成91过程中遇到的任何问题。',
    },
    {
      icon: 'ri-refresh-line',
      title: '实时更新',
      description: '成91最新入口地址和平台动态实时更新，收藏本页确保不错过任何重要信息。',
    },
    {
      icon: 'ri-lock-line',
      title: '安全护航',
      description: '多重安全防护机制，全方位保护您的账户安全和个人隐私，让您安心使用成91。',
    },
    {
      icon: 'ri-vip-crown-line',
      title: '会员尊享',
      description: '丰富的会员权益体系，不同等级享有专属特权，让您的成91使用体验更上一层楼。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择 <span className="text-primary-500">成91</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            成91始终以用户体验为核心，持续优化平台功能与服务，为广大用户提供安全、便捷、高效的使用体验。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}